import { render, staticRenderFns } from "./violationEventList.vue?vue&type=template&id=45abb516&scoped=true"
import script from "./violationEventList.vue?vue&type=script&lang=js"
export * from "./violationEventList.vue?vue&type=script&lang=js"
import style0 from "./violationEventList.vue?vue&type=style&index=0&id=45abb516&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45abb516",
  null
  
)

export default component.exports